module.exports = __webpack_public_path__ + "static/media/amy.a2655f6e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/amy.jpeg
// module id = 725
// module chunks = 0